import {
  composeValidators,
  EditableTextValue,
  LabelValue,
  LineClampContent,
  maxLength,
  pattern,
  required,
} from '@retail/components';
import React from 'react';
import { safeTextRegex } from '@retail/form/validation';
import { useAppTFunction } from '@retail/app/i18n';
import { MAX_CAMPAIGN_DESCRIPTION_LENGTH } from '../CreateCampaign';

interface Props {
  description?: string;
  onSave?: (description: string) => void;
}

export const CampaignDescription = ({ description, onSave }: Props) => {
  const t = useAppTFunction();
  const validation = composeValidators(
    required(t('validation.required')),
    maxLength(
      MAX_CAMPAIGN_DESCRIPTION_LENGTH,
      t('validation.maxLength', { max: MAX_CAMPAIGN_DESCRIPTION_LENGTH })
    ),
    pattern(safeTextRegex, t('validation.safeText'))
  );

  return (
    <LabelValue
      label={t('campaign.columns.description')}
      value={
        <EditableTextValue
          editable={!!onSave}
          renderValue={() => (
            <LineClampContent
              fontWeight={500}
              variant="body1"
              content={description ?? '-'}
              maxLines={2}
            />
          )}
          onSave={(desc) => onSave && onSave(desc)}
          defaultValue={description ?? ''}
          multiline
          maxLength={MAX_CAMPAIGN_DESCRIPTION_LENGTH}
          validate={validation}
          inputProps={{ sx: { marginBottom: 2 } }}
        />
      }
      orientation="vertical"
      spacing={0.5}
      valueProps={{ width: '100%' }}
    />
  );
};
